import {Component, OnInit} from '@angular/core';
import {exhaustMap, Observable} from 'rxjs';
import {CoreService, DocumentService, ProleisObject,} from 'proleis-rest-client';
import {ActivatedRoute} from '@angular/router';
import {RedirectService} from '../../../services/redirect.service';
import {GUID_ACTION_UI_SEND_TO_MACHINE, GUID_PATH_VIEW, GUID_TYPE_NCPROG} from "../../../../../p4m/guids";
import {map} from "rxjs/operators";
import {NotificationService} from "../../../../../p4m/notification.service";

@Component({
  selector: 'app-clamping',
  templateUrl: './clamping.component.html',
  styleUrls: ['./clamping.component.scss'],
})
export class ClampingComponent implements OnInit {
  clamping$: Observable<ProleisObject>;
  ncContainers$: Observable<ProleisObject[]>;
  documents$: Observable<ProleisObject[]>;
  ncFileObjects$: Observable<ProleisObject[]>;

  constructor(
    private coreService: CoreService,
    private documentService: DocumentService,
    private activatedRo: ActivatedRoute,
    private redirectService: RedirectService,
    private notificationService: NotificationService
  ) {
  }

  ngOnInit() {
    this.loadClamping();
    this.loadDocuments();
    this.loadNcFileObjects();
    this.loadNcContainers();
  }

  loadClamping() {
    const aliasFields =
      'NCPROGS=$JOIN(NCFILES, ",")' +
      ';POS_ID=PARENT[$ISPROJECTNODE=false].OBJECT_ID;POS_NAME=PARENT[$ISPROJECTNODE=false].TEXT' +
      ';BEMI_ID=PARENT[$ISPROJECTNODE=true].OBJECT_ID;BEMI_NAME=PARENT[$ISPROJECTNODE=true].TEXT;' +
      'PART_ID=PARENT[TYP_ID.GUID=b514dea4-27fa-11b2-800a-b390cd5bbe84].OBJECT_ID;PART_NAME=PARENT[TYP_ID.GUID=b514dea4-27fa-11b2-800a-b390cd5bbe84].TEXT;' +
      'PROJECT_ID=PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84];PROJECT_NAME=PARENT[TYP_ID.GUID=b514d7ec-27fa-11b2-800a-b390cd5bbe84].TEXT';
    this.clamping$ = this.coreService.getObjectById(
      this.activatedRo.snapshot.params.clampingId,
      aliasFields,
    );
  }

  loadDocuments() {
    this.documents$ = this.clamping$.pipe(
      exhaustMap((clamping) => {
        return this.documentService.getDocumentsInContainer(clamping.DOKUMENTCONTAINER_ID);
      }),
    );
  }

  loadNcFileObjects() {
    const aliasFields = 'SENDSTATUS=CALC_SENDSTATUS_ID.TEXT';
    this.ncFileObjects$ = this.clamping$.pipe(
      exhaustMap((clamping) => {
        const params = {
          IDS: clamping.NCPROGS,
        };
        return this.coreService.getObjectsQuery<ProleisObject[]>(
          'getObjectsById',
          params,
          aliasFields
        );
      }),
    );
  }

  loadNcContainers() {
    const aliasFields = "TYPGUID=TYP_ID.GUID";
    this.ncContainers$ = this.coreService.getChildren<ProleisObject[]>(
      this.activatedRo.snapshot.params.clampingId,
      `§${GUID_PATH_VIEW}`,
      aliasFields).pipe(
      map(result => {
        return result.filter(obj => obj.TYPGUID === GUID_TYPE_NCPROG)
      })
    );
  }

  redirect(objectId: string) {
    this.redirectService.redirectToInfoPanel(objectId);
  }

  sendToMachine() {
    this.coreService.executeAction(this.activatedRo.snapshot.params.clampingId, `§${GUID_ACTION_UI_SEND_TO_MACHINE}`).subscribe(result => {
      this.loadClamping();
      this.loadDocuments();
      this.loadNcFileObjects();
      this.loadNcContainers();

      this.notificationService.showNotification('Aufspannung an Maschine gesendet');
    });
  }
}
